<section *ngIf="backgroundImageUrl">
    <div class="image-holder" [ngStyle]="{'background': 'url(' + backgroundImageUrl + ') no-repeat', 'background-size': '100%'}"></div>
</section>